import yup from "src/utils/yup/extensionMethods";

const selecUserSchema = yup.object().shape({
	rib007Efa004Id: yup.string().nullable(),
	rib007Efa005Id: yup.string().nullable(),
	rib007Permissao: yup.number()
});

export const addAndChangeSchema = (translate: Function) => yup.object().shape({
	rib001Titulo:  yup.string().required(translate("Descrição é requerida")),
	rib001Data: yup.date().required(translate("A data é requerida")),
	rib001Situacao: yup.string().required(translate("A situacao é requerida")),
	rib001Quadrante: yup.string().required(translate("O quadrante é requerido")),
	rib001Efa005Id: yup.number().required(translate("O responsável é requerido")),
	rib001Ria001Id: yup.string().required(translate("A classificação é requerida")),
	rib001Probabilidade: yup.string().required(translate("A probabilidade é requerida")),
	rib001Impacto: yup.string().required(translate("O impacto é requerido")),
	rib001Descimpacto:  yup.string().nullable(),
	rib001Prevencao:  yup.string().nullable(),
	rib001Local: yup.string().nullable(),
	ritbb005: yup.array().of(yup.object().shape({
		rib005Descricao:  yup.string().required(translate("Descrição é requerida")),
		rib005Titulo: yup.string().required(translate("Título é requerido")),
		ritbb006: yup.array().of(yup.object().shape({
			rib006Titulo: yup.string().required(translate("Título é requerido")),
			rib006Efa005Id: yup.number().required(translate("O responsável é requerido")),
			rib006Como: yup.string().required(translate("Como é requerido")),
			rib006Dias: yup
				.number().required(translate("Dias é requerido"))
				.typeError(translate("Valor dos dias está incorreto"))
		})).min(1)
	})).min(0),
	ritbb007: yup.array()
		.of(selecUserSchema.required(translate("Necessário informar Campo")))
		.min(1,translate("Ao menos uma permissão deve ser informada"))
		.required(translate("Ao menos uma permissão deve ser informada"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.rib007Efa005Id, (a: any) => !a.rib007Efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.rib007Efa004Id, (a: any) => !a.rib007Efa005Id)
});

export const registerOccurenceSchema = (translate: Function) => yup.object().shape({
	rib004Motivo: yup.string().required(translate("Motivo é requerido")),
	actions: yup.array().of(yup.object().shape({
		rib006Titulo: yup.string().required(translate("Título é requerido")),
		rib006Efa005Id: yup.number().required("Responsavel é requerido"),
		expectedInitialDate: yup.date().nullable().required(  translate("Data Inicial é requerida")),
		expectedEndDate: yup.date().nullable().required(translate("Data Final é requerida")).min(
			yup.ref("expectedInitialDate"),
			translate("Data Final tem que ser após a Data Inicial")
		),
		rib006Como: yup.string().required("Como é requerido")
	})).min(0)
});

export const registerAnalysisSchema = (translate: Function) => yup.object().shape({
	rib003Descricao: yup.string().required(translate("Descrição é requerida")),
	rib003Probabilidade: yup.number().required(translate("Probabilidade é requerida")),
	rib003Impacto: yup.number().required(translate("Impacto é requerido")),
	rib003Ria002Id: yup.number().required(translate("Estratégia é requerida"))
});


export const deleteSchema = (translate: Function) => yup.object().shape({
	rib001Titulo: yup.string().required(translate("Titulo do risco não confere")).oneOf([yup.ref("rib001TituloConfirmation")], translate("Titulo do risco não confere"))
});
